export default {
  API_ENDPOINT: `https://desolate-beyond-31184.herokuapp.com/api`,
  API_KEY: process.env.REACT_APP_API_KEY,
  TOKEN_KEY: 'bl3tracker-client-auth-token'
};
